import { useEffect, useState } from "react";

import { Button, Header, Icon, Label, Select, Table, Image } from "semantic-ui-react";

import { DropdownOptions } from "../../constants";

import { LoadingSpinner, ErrorMessage, NoData } from "../../components";

import { User } from "../../models";

import { UserService, HelperService } from "../../services";


export function AdminsysUsersPage() {

    const maleAvatar = '/images/black-man.png'
    const femaleAvatar = '/images/black-woman.png'

    const [users, setUsers] = useState<User[]>([])
    const [userRole, setUserRole] = useState<string>('')
    const [loadingUsers, setLoadingUsers] = useState<boolean>(true)
    const [errorFetchingUsers, setErrorFetchingUsers] = useState<boolean>(false)

    useEffect(() => {

        setUserRole(HelperService.getRoleFromToken())

        UserService.getUsersList('sys')
            .then(data => setUsers(data))
            .catch(_ => setErrorFetchingUsers(true))
            .finally(() => setLoadingUsers(false))
    }, [])

    return <div>

        {loadingUsers && <LoadingSpinner />}

        {errorFetchingUsers && <ErrorMessage />}

        {
            !loadingUsers && !errorFetchingUsers &&
            <>
                <div className='headerRow'>
                    <div className="flex-center">
                        <h3 className='mb-0 mr-25'><Label color='orange'>{users.length}</Label> &nbsp; {userRole === 'Admin' ? 'Users' : 'Utilisateurs'}</h3>
                        <Select className='mr-25' placeholder='Filtrer par compagnie' options={DropdownOptions.agenciesOptions} />
                        <Select className='mr-25' placeholder='Filtrer par agence' options={DropdownOptions.agenciesOptions} />
                    </div>
                </div>

                {
                    users.length === 0 ?
                        <NoData /> :
                        <Table basic='very'>
                            <Table.Header>
                                <Table.Row>
                                    <Table.HeaderCell className="size-16">N°</Table.HeaderCell>
                                    <Table.HeaderCell className="size-16">Nom complet</Table.HeaderCell>
                                    <Table.HeaderCell className="size-16">Phone</Table.HeaderCell>
                                    <Table.HeaderCell className="size-16">Salaire</Table.HeaderCell>
                                    <Table.HeaderCell className="size-16">Statut</Table.HeaderCell>
                                    <Table.HeaderCell className="size-16">NIN</Table.HeaderCell>
                                    <Table.HeaderCell className="size-16">Role</Table.HeaderCell>
                                    <Table.HeaderCell className="size-16">Compagnie</Table.HeaderCell>
                                    <Table.HeaderCell className="size-16"></Table.HeaderCell>
                                </Table.Row>
                            </Table.Header>

                            <Table.Body>

                                {users.map(u =>
                                    <Table.Row key={u.id}>
                                        <Table.Cell>{u.id}</Table.Cell>
                                        <Table.Cell>
                                            <Header as='h4' image>
                                                <Image src={u.sex === 'M' ? maleAvatar : femaleAvatar} rounded size='mini' />
                                                <Header.Content>
                                                    {u.firstname + ' ' + u.lastname}
                                                    <Header.Subheader>{u.company?.name}</Header.Subheader>
                                                </Header.Content>
                                            </Header>
                                        </Table.Cell>
                                        <Table.Cell>{u.phone}</Table.Cell>
                                        <Table.Cell>{u.salary}</Table.Cell>
                                        <Table.Cell>{u.maritalStatus}</Table.Cell>
                                        <Table.Cell> {u.nin}</Table.Cell>
                                        <Table.Cell>{u.role}</Table.Cell>
                                        <Table.Cell>{u.company?.name}</Table.Cell>
                                        <Table.Cell textAlign='right'>
                                            <Button icon className='mr-10'><Icon name='cloud download' /></Button>
                                            <Button icon className='mr-10'><Icon name='trash alternate' /></Button>
                                            <Button icon className='mr-10'><Icon name='pencil alternate' /></Button>
                                            <Button icon className='mr-10'><Icon name='eye' /></Button>
                                        </Table.Cell>
                                    </Table.Row>
                                )}
                            </Table.Body>
                        </Table>
                }
            </>
        }
    </div>
}